"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.terminal_p = void 0;
function terminal_p(value) {
    return value.kind === "Value.str" || value.kind === "Value.pattern";
}
exports.terminal_p = terminal_p;
//# sourceMappingURL=value-terminal-p.js.map